export default __webpack_public_path__ + "static/media/connect-bottom.c27bf413.png";